<template>
    <div>
        <!-- Handle the toolbar action of creating a note -->
        <v-dialog v-model="noteDialog" max-width="800">
            <!-- Adding v-if will ensure the component is mounted each time we open the dialog and won't have to reset text area and validation -->
            <screening-note
                v-if="noteDialog"
                :order_id="currentScreen.order_id"
                :addresses="$_.get(currentScreen, 'applicant.addresses', [])"
                :employers="$_.get(currentScreen, 'applicant.employers', [])"
                @close="noteDialog = false"
            >
            </screening-note>
        </v-dialog>

        <v-dialog
            v-model="phoneDialog"
            :max-width="phoneDialogFullscreen ? '' : '600'"
            :fullscreen="phoneDialogFullscreen"
            persistent
        >
            <phone-viewer
                v-if="phoneDialog"
                :contacts="currentScreen.contacts"
                :applicant="currentScreen.applicant"
                :order_id="currentScreen.order_id"
                @show:info="showCallInfo"
                @close="
                    phoneDialog = false;
                    phoneDialogFullscreen = false;
                "
            ></phone-viewer>
        </v-dialog>
        <process-print-order
            v-if="printDialog"
            :order_id="$_.get(currentScreen, 'order_id', 0)"
            v-model="printDialog"
        >
        </process-print-order>
    </div>
</template>

<script>
import PhoneViewer from "@components/phone/components/PhoneViewer";
import ProcessPrintOrder from "@components/screen/components/Print/ProcessPrintOrder";
import ScreeningNote from "@components/screen/components/ScreeningProcessNote";

export default {
    name: "screening-process-actions",
    components: {
        PhoneViewer,
        ProcessPrintOrder,
        ScreeningNote,
    },
    props: {
        currentScreen: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            noteDialog: false,
            phoneDialog: false,
            phoneDialogFullscreen: false,
            printDialog: false,
        };
    },
    watch: {},
    methods: {
        showCallInfo(show) {
            this.phoneDialogFullscreen = show;
        },
        handleToolbarAction(action) {
            switch (action) {
                case "screening-toolbar-add-note":
                    this.noteDialog = true;
                    break;
                case "screening-toolbar-call":
                    this.phoneDialog = true;
                    break;
                case "screening-toolbar-print":
                    this.printDialog = true;
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>